import React, { useContext } from 'react';
import { AppContext } from '../context/AppContext';

// function customRound(value) {
//   let scaled = value * 1000;
//   let intPart = Math.floor(scaled);
//   let thirdDecimalDigit = intPart % 10;

//   let roundedNumber;
//   if (thirdDecimalDigit <= 5) {
//     roundedNumber = Math.floor(value * 100) / 100;
//   } else {
//     roundedNumber = Math.ceil(value * 100) / 100;
//   }

//   // Return as string fixed to 2 decimals, including trailing zeros
//   // return roundedNumber.toFixed(2);
//   return roundedNumber;
// }

function customRound(value) {
  // Convert to an integer representing the value * 1000 (to get 3 decimal digits)
  let scaled = Math.round(value * 1000); // avoid floating point errors
  let thirdDecimalDigit = scaled % 10;

  let roundedNumber;
  if (thirdDecimalDigit <= 5) {
    // Truncate to 2 decimal places
    roundedNumber = Math.floor(scaled / 10) / 100;
  } else {
    // Round up to next cent
    roundedNumber = Math.ceil(scaled / 10) / 100;
  }

  return roundedNumber;
}

const CurrencySymbol = (value, symbol, FractionDigits) => {
  const { currencySymbolLocation } = useContext(AppContext);
  const numericValue = Number(value);


 
  if (isNaN(numericValue)) {
    return `${symbol || ""} ${value}`;
  }

  const positiveValues = Math.abs(value); // Remove negative sign for display

  const roundedAmount = customRound(positiveValues);
  const formattedValue = roundedAmount.toLocaleString("en-US", {
    minimumFractionDigits: FractionDigits,
    maximumFractionDigits: FractionDigits,
  });;

  const isNegative = value < 0;

  const currencySymbol = symbol?.CurrencySymbol || symbol || "";
  // return `${currencySymbol}${formattedValue}`;

  return currencySymbolLocation == "AFTER NUMBER"
  ? `${isNegative ? "-" : ""}${formattedValue}${currencySymbol}`
  : `${isNegative ? "-" : ""}${currencySymbol}${formattedValue}`;
};


export default CurrencySymbol;

